/*
import React from "react";
import NofeshContext from "./search_panel.context";
export default class Provider extends React.Component {
  render() {
    return (
      <NofeshContext.Provider value={this.props.contextObject}>
        {this.props.children}
      </NofeshContext.Provider>
    );
  }
}
*/

import React from 'react';

const {
  Provider: NofeshServiceProvider,
  Consumer: NofeshServiceConsumer
} = React.createContext();

export {
  NofeshServiceProvider,
  NofeshServiceConsumer
};

